import * as React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Modal } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

interface Props {
  explainerModalOpen: boolean;
  setExplainerModalOpen: (value: boolean) => void;
}

const MarketMapExplainer: React.FC<Props> = (props) => {
  const { explainerModalOpen, setExplainerModalOpen } = props;

  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Modal
        title="Explainer"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 'auto',
        }}
        open={explainerModalOpen}
        onClose={() => setExplainerModalOpen(false)}
      >
        <div
          style={{
            flex: 1,
            background: 'white',
            maxHeight: '75%',
            maxWidth: '75%',
            overflow: 'auto',
            padding: '15px',
            fontSize: 12,
            fontFamily: 'OpenSans, sans-serif',
            color: '#022950',
          }}
        >
          <p>{t('reports.marketMap.explainers.overall')}</p>
          <p>
            <b>{t('reports.marketMap.vectors')}</b>{' '}
            {t('reports.marketMap.explainers.vectors')}
          </p>
          <p>
            <b>{t('reports.marketMap.points')}</b>{' '}
            {t('reports.marketMap.explainers.points')}
          </p>
          <p>
            <b>{t('reports.marketMap.products')}</b>{' '}
            {t('reports.marketMap.explainers.products')}
          </p>
          <p>
            <b>{t('reports.marketMap.pixels')}</b>{' '}
            {t('reports.marketMap.explainers.pixels')}
          </p>
          <p>
            <b>{t('reports.marketMap.contours')}</b>{' '}
            {t('reports.marketMap.explainers.contours')}
          </p>
        </div>
      </Modal>
      <IconButton
        onClick={() => setExplainerModalOpen(!explainerModalOpen)}
        size="large"
      >
        <InfoOutlinedIcon style={{ fontSize: 24, color: '#777' }} />
      </IconButton>
    </React.Fragment>
  );
};

export default MarketMapExplainer;
